import { lockSession } from '../identity/ZionIdentityManager.ts'
import { clearAllMediaCache } from '../media/mediaCache.ts'
import { clearAllMessages } from '../storage/chatStore.ts'
import { clearAllKeys } from '../storage/keyStore.ts'
import { clearLegalAcceptance } from '../storage/legalStore.ts'
import { clearAllContacts } from '../storage/pairingStore.ts'
import { clearAllTempChats } from '../storage/tempChatStore.ts'
import { clearSession } from '../storage/sessionStore.ts'
import { disconnectSocket } from '../socket2/ZionSocketClient.ts'
import { disableWebPush } from '../push/webPush.ts'

const EXTRA_DBS = [
  'zion-socket-auth',
  'zion-pairing-payload',
  'zion-license',
  'zion_contacts_db',
  'zion_session_sw',
] as const

async function deleteIndexedDb(name: string): Promise<void> {
  await new Promise<void>((resolve) => {
    const req = indexedDB.deleteDatabase(name)
    req.onsuccess = () => resolve()
    req.onerror = () => resolve()
    req.onblocked = () => resolve()
  })
}

/** Cancella tutti i dati locali — zero-knowledge reset. */
export async function factoryResetAllData(): Promise<void> {
  disconnectSocket()
  lockSession()
  try {
    const toRemove: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i)
      if (k?.startsWith('zion_')) toRemove.push(k)
    }
    toRemove.forEach((k) => localStorage.removeItem(k))
  } catch {
    /* ignore */
  }
  await disableWebPush().catch(() => {})
  clearAllTempChats()
  await clearAllMediaCache()
  await Promise.all([
    clearAllKeys(),
    clearSession(),
    clearAllContacts(),
    clearAllMessages(),
    clearLegalAcceptance(),
    ...EXTRA_DBS.map((db) => deleteIndexedDb(db)),
  ])
  try {
    sessionStorage.clear()
  } catch {
    /* ignore */
  }
}

/** Wipe volatile: session + cache app (senza chiavi se non richiesto). */
export async function wipeVolatileOnExit(): Promise<void> {
  lockSession()
  try {
    sessionStorage.clear()
  } catch {
    /* ignore */
  }
  if ('caches' in window) {
    try {
      const keys = await caches.keys()
      await Promise.all(keys.filter((k) => k.startsWith('zion')).map((k) => caches.delete(k)))
    } catch {
      /* ignore */
    }
  }
}
